import React from "react";

import "../scss/Elements/_tables.scss";
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { ClientsTableAxios } from "../components/Tables/ClientsTable";

function Clients() {
  const { titleClientsString } = useTranslationHook();

  return (
    <div className="table-module-container">
      <Helmet>
        <title>{titleClientsString}</title>
      </Helmet>
      <div className="datatable">
        <ClientsTableAxios />
      </div>
    </div>
  );
}

export default Clients;
